import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Hotfix 2026-05-23 (FE-139 sibling) — alias route.
 * See _auth.finance.regulatory.esf.tsx for context.
 */
export const Route = createFileRoute('/_auth/finance/regulatory/kpn')({
  beforeLoad: () => {
    throw redirect({ to: '/finance/kpn' });
  },
});
